module.exports = __webpack_public_path__ + "img/bus-transports.215fd017.jpg";